<template>
  <div>
    <CRUD
      v-if="editItem || deleteItem"
      :edit-item="editItem"
      :delete-item="deleteItem"
      @edited="onCloseEdit"
      @deleted="onCloseDel"
      @closed="onCloseNew"
    ></CRUD>
    <v-card v-else outlined>
      <v-card-title>
        <h4>{{ item.name }}</h4>
        <v-spacer></v-spacer>
        <v-menu left bottom>
          <template v-slot:activator="{ on }">
            <v-btn outlined color="primary" icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group>
              <v-list-item @click="onEdit(item)">
                <v-list-item-icon>
                  <v-icon>edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item @click="onDelete(item)">
                <v-list-item-icon>
                  <v-icon>delete</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-divider></v-divider>
      <v-list>
        <v-list-group
          v-for="[cmd, paras] in getParameters(item)"
          :key="cmd"
          :value="false"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="cmd.toUpperCase()"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="[k, v] in Object.entries(paras)" :key="k" two-line>
            <v-list-item-icon>
              <v-icon v-if="!v.value">check_box_outline_blank</v-icon>
              <v-icon v-else>check_box</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="k"></v-list-item-title>
              <v-list-item-subtitle v-text="v.name"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-text="v.value"></v-list-item-title>
              <v-list-item-subtitle v-text="v.unit"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-text="v.overwriteIfNone ? 'Yes' : 'No'"></v-list-item-title>
              <v-list-item-subtitle>Overwrite If None</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-text="v.overwriteAlways ? 'Yes' : 'No'"></v-list-item-title>
              <v-list-item-subtitle>Overwrite Always</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CRUD from "@/components/strategies/CRUD.vue";

export default {
  name: "Card",
  components: {
    CRUD
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      parameters: null,
      editItem: null,
      deleteItem: null
    };
  },
  computed: {
    ...mapGetters(["strategies", "currentUser"])
  },
  methods: {
    onEdit(item) {
      this.editItem = item;
    },
    onDelete(item) {
      this.deleteItem = item;
    },
    onCloseEdit() {
      this.editItem = null;
    },
    onCloseDel() {
      this.deleteItem = null;
    },
    onCloseNew() {
      this.editItem = null;
      this.deleteItem = null;
    },
    getParameters(item) {
      let a = Object.entries(item);
      return a.filter(v => {
        return (
          v[0] != "id" &&
          v[0] != "userId" &&
          v[0] != "timestamp" &&
          v[0] != "name"
        );
      });
    }
  }
};
</script>
<style></style>
